<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1" id="frontis">
<img alt="Col. Washington was in the thickest of the fight" class="w" id="id-3780272861179908462" src="Images/img0001.jpg"/>
<div class="caption">
<p class="caption1">Col. Washington was in the thickest of the fight.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?4770732f